import styled from '@emotion/styled'

export const Container = styled.div(({ theme }) => ({
    width: '100%',
    height: '100vh',
}))